import i18n from '../../plugins/i18n';

const validationRules = {
    getRequiredRule(fieldName: string) {
        return (value: string): boolean | string => !!value || i18n.t('validation.required', { name: fieldName }).toString()
    },
    getMaxLengthRule(fieldName: string, maxLength: number) {
        return (value: string): boolean | string => (value && value.length <= maxLength) || i18n.t('validation.maxlength', { name: fieldName, length: maxLength }).toString()
    },
    getEmailRule(fieldName: string) {
        return (value: string): boolean | string => /.+@.+\..+/.test(value) || i18n.t('validation.email', { name: fieldName }).toString();
    },

};

export default validationRules;
